import React, { useEffect, useState } from 'react';
import { Upload, X, Image as ImageIcon } from 'lucide-react';
import { adminApi } from '../api';

// Image field: shows preview, allows upload (returns absolute URL) or manual URL.
export function ImagePicker({ label, value, onChange, tenantId }) {
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const m = await adminApi.uploadMedia(file, tenantId);
      onChange(m.url);
    } catch (e) {
      alert('Upload fallito: ' + (e.response?.data?.detail || e.message));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div>
      {label && <span className="mb-1 block text-sm font-medium text-paelbi-ink/80">{label}</span>}
      <div className="flex items-center gap-3">
        <div className="flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-paelbi-line bg-paelbi-bg">
          {value ? <img src={value} alt="anteprima" className="h-full w-full object-cover" /> : <ImageIcon size={20} className="text-paelbi-ink/40" />}
        </div>
        <div className="flex-1">
          <input
            value={value ?? ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder="URL immagine"
            className="w-full rounded-lg border border-paelbi-line bg-white px-3 py-2 text-sm outline-none focus:border-paelbi-brown"
          />
          <div className="mt-2 flex items-center gap-2">
            <label className="inline-flex cursor-pointer items-center gap-1.5 rounded-lg bg-paelbi-brown px-3 py-1.5 text-xs font-semibold text-white hover:bg-paelbi-brown-dark">
              <Upload size={14} /> {busy ? 'Carico...' : 'Carica'}
              <input type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files[0])} />
            </label>
            {value && (
              <button type="button" onClick={() => onChange('')} className="inline-flex items-center gap-1 rounded-lg border border-paelbi-line px-3 py-1.5 text-xs text-paelbi-ink/70">
                <X size={14} /> Rimuovi
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImagePicker;
